export default __webpack_public_path__ + "static/media/mallory_compact_x_light_italic.79c54e8e.ttf";